import {
  findSectionIdFromProduct,
  findSectionNameById,
  findEvaluationDetailsByPaperIdAndDate,
  findSubsectionDetailsById,
  findCandidateResultByID,
  isAddNationalAverage,
  findPapersByTestTrackId,
} from 'gql/query'
import { nationalAverageForSectionWise, changeFormatCandidateWise } from './nationalAverageForSectionWise'
import { ISectionBaseNationalAvg, ISubsection } from 'type'
import { changeformat } from './sectionBasedFormat'

//---------------------------------------------------------------------------------------------->
const findTotalSectionalAverage = async (data: any) => {
  try {
    if (data.length > 0) {
      let total_marks = 0
      let total_marks_obtained = 0
      await data.forEach(async (item: any) => {
        total_marks += item.totalMarks
        total_marks_obtained += item?.totalMarksObtained
        item.sectional_average = ((await parseInt(item?.totalMarksObtained)) / parseInt(item?.totalMarks)) * 100
      })
      const national_average_of_paper = (total_marks_obtained / total_marks) * 100
      return { data, national_average_of_paper }
    } else {
      return { message: "Can't add now, there is no related papers " }
    }
  } catch (err) {
    return { message: 'unexpected issues found.........' }
  }
}
//---------------------------------------------------------------------------------------------------------------------
export const isCalculateNationalAverage = async (testTrackId: string, productId?: string) => {
  try {
    const currentDate: number = Date.now()
    const formatedCurrentDate: Date = new Date(currentDate)
    //finding national average with productId and test track
    const addNationalAverage: any = await isAddNationalAverage(testTrackId, productId)
    //if national average is already there
    if (addNationalAverage?.national_average.length > 0) {
      const createdDate: string = addNationalAverage?.national_average[0]?.created_at
      const nationalAverageId: string = addNationalAverage?.national_average[0]?.id
      const newCreateDate: Date = new Date(createdDate)
      const timeDifference: number = formatedCurrentDate.getTime() - newCreateDate.getTime()
      const daysDifference: number = timeDifference / (1000 * 60 * 60 * 24)
      //Is national average created before 30 days
      //user have to update
      if (daysDifference > 30) {
        return { status: false, canUpdate: true, id: nationalAverageId }
      } else {
        //user can't update
        return { status: true, addNationalAverage }
      }
    } else {
      //its not present then user have to create new one
      return { status: false }
    }
  } catch (err) {
    console.log(err, ':error ')
  }
}

export const findNationalAverage = async (testTrackId: string, productId?: string) => {
  try {
    const questionsWithSameProductIdAndTestTrackId: any = await findPapersByTestTrackId(testTrackId, productId)
    const relatedPapers = questionsWithSameProductIdAndTestTrackId?.papers
    const currentDate = Date.now()
    const formatedCurrentDate = new Date(currentDate)
    formatedCurrentDate.setDate(formatedCurrentDate.getDate() - 30)
    const dateThirtyDaysAgo = formatedCurrentDate.toISOString()
    const responseEvaluationDetailsForPaper: any[] = []
    //if papers are there
    if (relatedPapers.length > 0) {
      // Used Promise.all to wait for all asynchronous operations to complete
      await Promise.all(
        relatedPapers.map(async (item: any) => {
          // Find the evaluation details within a particular time and a paperId
          let responseFromFindingEvaluationDetails: any = await findEvaluationDetailsByPaperIdAndDate(item?.id, dateThirtyDaysAgo)
          if (responseFromFindingEvaluationDetails?.evaluations.length > 0) {
            responseEvaluationDetailsForPaper.push(...responseFromFindingEvaluationDetails?.evaluations)
          }
        })
      )
    } else {
      console.log('papers')
      return { status: false, message: "Can't add now, there is no related papers" }
    }
    //changed the format, formated the data by each candidate wise
    const newEvaluationDetails: any = await changeFormatCandidateWise(responseEvaluationDetailsForPaper)
    const paperSubsectionDetails: ISubsection[] = []
    if (newEvaluationDetails.length > 0) {
      //total candidates
      for (let candidate = 0; candidate < newEvaluationDetails?.length; candidate++) {
        let candidateDetails = newEvaluationDetails[candidate]
        //finding each candidate result
        const candidataAnswers: any = await findCandidateResultByID(candidateDetails?.id)
        //finding users answers for each questions
        const answers = candidataAnswers?.evaluation_details[0].answers
        //paper subsections and questions of that subsection
        const paperSubsectionsWithItsIds = candidateDetails?.paper?.subSectionQuestions
        //iterating through all the section
        for (let i = 0; i < paperSubsectionsWithItsIds?.length; i++) {
          //geting all subsection details like section name,section Id etc
          let response: any = await findSubsectionDetailsById(paperSubsectionsWithItsIds[i]?.id)
          let subsectionDetails = response?.paper_template_sub_sections[0]
          const subsectionObject: ISubsection = {
            subsection: subsectionDetails,
            question: [],
          }
          //pushing all subsection
          paperSubsectionDetails.push(subsectionObject)
          //iterating through all the questions in a subsection
          for (let j = 0; j < paperSubsectionsWithItsIds[i].questionIds.length; j++) {
            let questionDetails: any = {}
            //evaluation happening on the questions which are ordered in subsection question in a paper
            //
            questionDetails.candidateResult = answers.shift()
            paperSubsectionDetails[paperSubsectionDetails.length - 1].question?.push(questionDetails)
          }
        }
      }
      //change the formating, for grouping same subsection together
      const sectionBasedFormatedData = await changeformat(paperSubsectionDetails)
      const totalAndSectionalAverages = await findTotalSectionalAverage(sectionBasedFormatedData)
      return { status: true, totalAndSectionalAverages }
    } else {
      return { status: false, message: 'No evaluation has taken place in the last 30 days...' }
    }
  } catch (err) {
    return { status: false, message: 'unexpected errors found............' }
  }
}
